import { useState } from "react";

export const useCardToken = (stripe: any): [string | null, (c: any) => Promise<void>, () => void, string | null] => {
    const [tokenState, setToken] = useState<string | null>(null);
    const [tokenError, setTokenError] = useState<string | null>(null);
    const generateCardToken = async (card: any): Promise<void> => {
        const response = await stripe.createToken(card);
        if (response.token) {
            setToken(response.token.id);
        }
        if (response.error) {
            const { decline_code } = response.error
            setTokenError(`${decline_code}`);
        }

    }

    const reset = () => {
        setToken(null);
        setTokenError(null)
    };
    return [tokenState, generateCardToken, reset, tokenError];
}
